<template lang="html">

  <div>

    <form @submit.prevent="validation">

      <h2 class="title-dato" :style="getStyles.white">{{$t('login.iniciar_sesion')}}</h2>

      <div class="contenedor-input">
        <label for="usuario">{{$t('login.email')}}</label>
        <input type="text" v-model="data.eUsuario" id="usuario" :hasContent="!!data.eUsuario">
        <span class="error -email" v-if="view.showEmailError">{{$t('login.error_mail')}}</span>
      </div>

      <div class="contenedor-input" @mouseleave="view.revealPass = false">
        <label for="password">{{$t('login.contrasena')}}</label>
        <input :type="view.revealPass ? 'text' : 'password'" v-model="data.ePassword" id="password" :hasContent="!!data.ePassword" >
        <reveal class="revealPass" :isReveal="view.revealPass" ></reveal>
        <i @click="view.revealPass = !view.revealPass" class="revealPass"></i>
        <a class="link -white lostPass" @click="$emit('revealRecuperar')">{{$t('login.contrasena_olvidada')}}</a>
      </div>

      <div class="column-center contenedor-boton">

        <span class="error-email column-center" :show="view.showEmailPopup">
          <span @click="view.showEmailPopup = false">✕</span>
          <p v-html="$t('login.indica_mail')"></p>
        </span>

        <button class="btn -solid-primary" :loading="view.loading">{{$t('login.acceder')}}</button>

        <router-link class="link -white register-link" :to="$t('enlaces.solicitar_cuenta')">
          {{$t('login.aun_no_registrado')}}
          <template v-if="brand.name=='nebrija'"><br>{{$t('login.alta_nueva_empresa')}}</template>
        </router-link>

      </div>

    </form>



  </div>


</template>

<script lang="js">


  import {mapActions, mapGetters} from 'vuex';

  import router from '@/router'

  import reveal from '@/components/parts/icons/reveal'

  export default  {
    name: 'form-empresa',
    props: [],
    data() {
      return {
       data : {
        eUsuario : '',
        ePassword : '',
        eAmbito : 'PrivadoEmpresa'
      },
      view : {
        revealPass : false,
        showLostPass : false,
        showEmailError : false,
        showEmailPopup : false,
        loading : false
      }
    }
  },
  components :{
    'reveal' : reveal
  },
  methods: {
    validation : function(){

      this.view.showEmailPopup = (!this.data.eUsuario.includes('@') && this.view.showEmailError);

      this.view.showEmailError = (!this.data.eUsuario.includes('@'));

      if(this.canSend & !this.view.showEmailError){
        this.view.loading = true;
        this.dameEmpresasUsuario(this.data).then(response => {
          console.log(response);
          this.view.loading = false;
          (response) ? this.loginOk() : null;
        });
      }
    },
    loginOk : function(){
      this.loading = false;
      router.push('/');
    },
    ...mapActions(['dameEmpresasUsuario','changeRemember'])
  },
  computed : {
    ...mapGetters({
      getRememberMe: 'getRememberMe',
      getStyles: 'getStyles',
      getLogo: 'getLogo',
      basicColors: 'basicColors',
      brand: 'getBrand'
    }),
    ownstyles : function(){
      return {
        input : {
          'border-bottom' : `1px solid ${this.basicColors.white}`
        }
      }
    },
    canSend : function(){
      var can = (!!this.data.eUsuario && !!this.data.ePassword);
      return can;
    },
    samebackandbutton(){
      return (this.basicColors.basic == this.basicColors.button)
    }
  }
}
</script>

<style scoped lang="scss">

  form{
    max-width: 400px;
    padding: 0 15px;
    width: 100%;
  }

  .logo{
    margin-bottom: 40px;
  }

  .title-dato{
    margin-bottom: 40px;
  }

  .contenedor-botones{
    width: 100%;
  }

  .btn{
    margin-top: 50px;
  }

  .register-link{
    text-align: center;
    width: 100%;
    margin-top: 20px;
  }

  .contenedor-input.type-checkbox{
    margin-top: 20px;
  }

  .contenedor-boton{
    position: relative;
    overflow: hidden;
  }
  .contenedor-input input{
    border-bottom: 1px solid currentColor;
  }


  .error-email{
    position: absolute;
    left: 0;
    top: 100%;
    background: white;
    color: #000;
    width: 100%;
    padding: 20px;
    font-size: 16px;
    height: 100%;
    transition: .5s;

    &[show=true]{
      transform: translateY(-100%);
    }

    p{
      text-align: center;
      margin-bottom: 0;
    }

    strong{
      display: inline-block;
      font-weight: 700;
    }

    span{
      position: absolute;
      right: 10px;
      top: 5px;
      cursor: pointer;
    }
  }

  .error.-email{
    font-size: 14px;
    bottom: -5px;
  }

  @media screen and (max-height: 700px){

    .title-dato{
      margin-bottom: 20px;
    }

    .contenedor-botones{
      margin-top: 20px;
    }

  }

  @media screen and (max-width: 415px){
    form{
      padding: 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/views/login/form-empresa.vue